import STORE_TYPES_PRODUCT_VARIATIONS from '@/web/store/types/product-variations'

const state = {
  activeProduct: {},
  origin: '',
  selected: {},
  isVisible: false
}

const getters = {
  [STORE_TYPES_PRODUCT_VARIATIONS.GETTERS.GET_ACTIVE_PRODUCT]: state => {
    return state.activeProduct
  },
  [STORE_TYPES_PRODUCT_VARIATIONS.GETTERS.GET_SELECTED_VARIATION]: state => {
    return state.selected
  },
  [STORE_TYPES_PRODUCT_VARIATIONS.GETTERS.GET_VARIATIONS_ORIGIN]: state => {
    return state.origin
  },
  [STORE_TYPES_PRODUCT_VARIATIONS.GETTERS.GET_IS_PRODUCT_VARIATIONS_VISIBLE]: state => {
    return state.isVisible
  }
}

const mutations = {
  [STORE_TYPES_PRODUCT_VARIATIONS.MUTATIONS.SET_ACTIVE_PRODUCT]: (state, payload) => {
    state.activeProduct = payload
  },
  [STORE_TYPES_PRODUCT_VARIATIONS.MUTATIONS.SET_SELECTED_VARIATION]: (state, payload) => {
    state.selected = payload
  },
  [STORE_TYPES_PRODUCT_VARIATIONS.MUTATIONS.SET_VARIATIONS_ORIGIN]: (state, payload) => {
    state.origin = payload
  },
  [STORE_TYPES_PRODUCT_VARIATIONS.MUTATIONS.SET_IS_PRODUCT_VARIATIONS_VISIBLE]: (state, payload) => {
    state.isVisible = payload
  }
}

const actions = {
  [STORE_TYPES_PRODUCT_VARIATIONS.ACTIONS.TOGGLE_PRODUCT_VARIATIONS]: ({ commit }, { visible, origin, product }) => {
    if (product)
      commit(STORE_TYPES_PRODUCT_VARIATIONS.MUTATIONS.SET_ACTIVE_PRODUCT, product)

    commit(STORE_TYPES_PRODUCT_VARIATIONS.MUTATIONS.SET_VARIATIONS_ORIGIN, origin)
    commit(STORE_TYPES_PRODUCT_VARIATIONS.MUTATIONS.SET_IS_PRODUCT_VARIATIONS_VISIBLE, visible)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
